/**
 * Columns configuration for percentage of redos table.
 * Each column has a label and a key that corresponds to the data field.
 */
export const percentageOfRedosColumns = [
    { label: "S.No.", key: "sno" }, // Serial number of the row
    { label: "Months", key: "month" }, // Month of the data
    { label: "Total Reports", key: "totalReports" }, // Total number of reports
    { label: "Reports with Redo", key: "reportsWithRedoCount" }, // Number of reports that required redo
    { label: "% of Redo Reports", key: "percentageRedos" } // Percentage of redos
];

/**
 * Columns configuration for average TAT (Turnaround Time) table.
 * Each column has a label and a key that corresponds to the data field.
 */
export const avgTATColumns = [
    { label: "S.No.", key: "sno" }, // Serial number of the row
    { label: "Modality", key: "modality" }, // Type of modality used
    { label: "Total Reports", key: "totalReports" }, // Total number of reports
    { label: "Total Patient Appointments", key: "totalAppointments" }, // Total number of patient appointments
    { label: "Avg TAT(hours)", key: "avgTAT" } // Average turnaround time in hours
];

export const delayedReportsModalityWiseColumns = [
    { label: "S.No.", key: "sno" }, // Serial number of the row
    { label: "Modality", key: "modality" }, // Type of modality used
    { label: "Total Reports", key: "totalReports" }, // Total number of reports
    { label: "Total Delayed Reports", key: "totalDelayedReports" }, // Total number of delayed reports
    { label: "% of delayed reports", key: "percentageDelayedReports" } // Percentage of delayed reports
]

export const critialTestReportedColumns = [
    { label: "S.No.", key: "sno" },
    // { label : "Current Month Appointment", key: "currentMonthAppointmentResult" }, // Current month appointment
    { label : "% of Critical Appointments", key: "criticalAppointments" }, // Percentage of critical appointments
];
